import React, { useState, useEffect, Fragment, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import i18n from "../../i18n";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import 'aos/dist/aos.css';
import Aos from "aos";
import { config } from "../../api/api";

import $ from 'jquery';






function MotorRenewPolicy() {

    
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
   
    // const api_headers = {
    //     'Authorization': 'Bearer ' + vendor_key,
    //     'Content-Type': 'application/json' // Ensure you're sending JSON
    // }
    const base_url = config.baseURL;
    const redirecturl = config.redirectURL;


    const { t } = useTranslation();

 const [isHidePage,setIsHidePage]=useState("");
    const [sanadDetails,setSanadDetails]=useState(null);
    const [openPaymentOption,setOpenPaymentOption]=useState(false);

      const [quoteDetails,setQuoteDetails]=useState(null);
      const [vehicleDetails,setVehicleDetails]=useState(null);
      const [insuredDetails,setInsuredDetails]=useState(null);
      const [transactionDetails,setTransactionDetails]=useState(null);
      const civilNoRef=useRef(null);
      const quoteRef=useRef(null);
      const regNoRef=useRef(null);
      const regMarkRef=useRef(null);
      const [error,setError]=useState({
         civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""
      });

      const [loading,setLoading]=useState(false);

      const [formData,setFormData]=useState({
        civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""

      })

      const [buttonClicked,setButtonClicked]=useState("");

    const reg_type = ["Oman Plate", "GCC Plate", "Import", "Export"];
    const reg_mark = [
          "10", "11", "12", "14", "15", "16", 
          "A A", "B K", "D D", "H W", "A D", "M", "A R", "H H", 
          "L K", "H A", "B M", "BANK", "C D", "D A", "Inspection", 
          "M B", "M S", "MUSCAT", "R A", "R H", "T", "T B", "W A", 
          "1", "2", "3", "4", "5", "6", "7", "8", "9", "L D", "M L", 
          "M Y", "Y M", "Y R", "M W", "R R", "T A", "T B A", "Y", 
          "A W", "K B", "L A", "K H", "M D", "M K", "R W", "Y W", 
          "A Y", "B B", "B H", "D H", "D Y", "H", "I N T L", "K", 
          "D R", "D S", "H Y", "IMPORT", "J", "K A", "B R", "B S", 
          "D", "D W", "H K", "H M", "H R", "R", "T T", "Y A", "Y B", 
          "R K", "R S", "W", "Y D", "Y Y", "K K", "S S", "Y S", "A", 
          "B", "B D", "A B", "A K", "A S", "B W", "B Y", "D K", 
          "H D", "H S", "M A", "A M", "M M", "M R", "R M", "S", 
          "S H", "W B", "W K", "T H", "T D", "R Y", "W W", "L B", 
          "L A", "L H", "B A", "M H", "17", "18", "19", "20", "21", 
          "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", 
          "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", 
          "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", 
          "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", 
          "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", 
          "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", 
          "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", 
          "92", "999", "UAE", "Dubai", "Abu Dhabi", "Fujairah", "Sharjah", 
          "Qatar", "Kuwait", "KSA", "Ras Al - Khaimah", "Umm Al - Quwain", 
          "Ajman", "Bahrain"
        ];

          const selectOpt1=useRef(null);
    const [vendorKey,setVendorkey]=useState("");

          
    useEffect(() => {
  
      const postvData = { organization_name: "Superjet" };
      debugger
  
      if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
  
        debugger
        fetch(base_url + '/create_organization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData),
        })
          .then(response => response.json())
          .then(data => {
            setVendorkey(data.result[0].vendor_key);
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });
  
  
      }
    }, [vendorKey]);

    useEffect(() => {
  if(formData.civil_no && formData.civil_no.length >= 5 && formData.quote_id){
    setError({
         civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""
      });
  } else if(formData.civil_no && formData.civil_no.length >= 5 && formData.registration_mark && formData.registration_number) {
    setError({
         civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""
      });
  }

    },[formData])     

        const handleChange=(e)=>{

            const {name,value}=e.target;
            const trimValue=value.trimStart();
            setFormData((prev)=>({...prev,[name]:trimValue}));


        }

        const handleValidationRegMark=(name,value)=>{
            const trimValue=value;
            debugger
  if(name==="registration_mark" ){
                debugger
                if(!trimValue || trimValue==="--Select--" || trimValue==="--يختار--"){
                  setError((prev)=>({...prev,[name]:"Registration mark is required."}))
    setFormData((prev)=>({...prev,registration_mark:""}))
             
                return;
                }
                else{
                  setError((prev)=>({...prev,[name]:""}));
    setFormData((prev)=>({...prev,registration_mark:trimValue}))

                return;
                }
              }  
        }

        const handleValidation=(e)=>{
          const {name,value}=e.target;
            const trimValue=value.trimStart();
            if(name==="civil_no"){
                if(!trimValue){
                setError((prev)=>({...prev,[name]:"Civil no is required."}))
                return;
                }
                else if(trimValue.length<5){
                setError((prev)=>({...prev,[name]:"Civil no required should be minimum 5 digit"}))

                }
                else{
                   setError((prev)=>({...prev,[name]:""}))
                  return;
                }
            }

     
          if(name==="quote_id"){

              if(!trimValue){
                  setError((prev)=>({...prev,[name]:"Quote ID is required."}))
                return;
              }
              else{
                  setError((prev)=>({...prev,[name]:""}))
                  if(formData.quote_id && formData.civil_no && formData.civil_no.length>=5){
                    setError({
         civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""
      });
                  }
                return;
              }
          }
        
    
                 
            if(name ==="registration_number"){
              if(!trimValue){
                  setError((prev)=>({...prev,[name]:"registration number is required."}));
                return;
            }
             else{
                  setError((prev)=>({...prev,[name]:""}));
                return;
                }
      }
        
      }

      const handleSubmit=(e)=>{
        e.preventDefault();
          let valid =true;

            //check civil No

            if(!formData.civil_no){
                valid =false;
                 setError((prev)=>({...prev,civil_no:"Civil no is required."}))
                civilNoRef.current.focus();
            }

      if(!formData.registration_mark && !formData.registration_number){
          if(!formData.quote_id){
             valid =false;
                 setError((prev)=>({...prev,quote_id:"Quote ID is required."}));
                 if(formData.civil_no){
                quoteRef.current.focus();
                 }

                
          }
        

      }
      else if(formData.registration_mark || formData.registration_number){
         setError((prev)=>({...prev,quote_id:""}));
              if(!formData.registration_mark ){
debugger
               valid =false;
                setError((prev)=>({...prev,registration_mark:"Registration mark is required."}))
                  if(formData.civil_no){
                    $(selectOpt1.current)
  .next('.select2-container')
  .find('.select2-selection')
  .trigger('mousedown');
    //              $(selectOpt1.current).select2('open');
    // $(selectOpt1.current).next('.select2-container')[0]?.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'center',
    // });
                  }
               
              }
                
            if(!formData.registration_number){
               valid =false;
                setError((prev)=>({...prev,registration_number:"Registration Number is required."}));
                if(formData.civil_no && formData.registration_mark){
                regNoRef.current.focus();
                }
            }
      }
      if(valid){
 const req_data= {
    civilId:formData.civil_no,
    plateNo: formData.registration_number || "" ,
    registrationMark:formData.registration_mark || "",
    srcBusId: "BOT",
    txnTyp:"Q",
    mobileNo:"",
    policyNo:"",
    quoteNo:formData.quote_id||"",
    searchTyp:"PS"

}

sessionStorage.setItem("motorRenewalInfo",JSON.stringify(req_data));
 
window.location.href="/motor-renew-quote";
      }

    }

 
        const handleChangeRegMark=(name,value)=>{
              debugger
           if(!value){
            setFormData((prev)=>({...prev,[name]:value}));
           }

        }
useEffect(() => {
  const $select = $(selectOpt1.current);

  // Initialize Select2
  $select.select2({ width: "resolve"})

  // Define event handlers
  const handleSelect = (e) => {
    debugger
    // handleChangeRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);

  };

  const handleClose = (e) => {
    debugger
    handleValidationRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);
    // handleChangeRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);
  };

  // Attach handlers
  $select.on('select2:select',(e)=> handleSelect(e));
            //   $(selectOpt1.current).on('select2:select', (e) => {
  
  $select.on('select2:close',(e) => handleClose(e));

  // Cleanup
  return () => {
    $select.off('select2:select', handleSelect);
    $select.off('select2:close', handleClose);
    $select.select2('destroy');
  };
}, [reg_mark]);



      

        useEffect(()=>{
            console.log("formData");
            console.log(formData);
        },[formData]);

   return (
    <>
          <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Renew Policy' : 'تجديد السياسة'}</h3>
          </div>
        </div>

      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">


   <>
                  <div className="row mb-3">
                      <div className="col-md-12">

                        
                
             
                    {/* <h3 className="mt-3">{t("Renew your policy")}</h3> */}
                   
<div className="card shadow p-3 mb-5 bg-body rounded">

               
 
  {/* civil no */}
   <div className="px-3">
                 <div className="input-group mb-2 mt-4  ">
                    <div className="input-group-prepend prepends">
                      <span className="input-group-text">{(lnstr === 'en') ? 'Civil No' : 'الرقم المدني'}<span style={{color:'red', marginLeft: '5px'}}>*</span></span>
                    </div>
                    <input type="text" name="civil_no" ref={civilNoRef} className="form-control "  value={formData?.civil_no} onBlur={handleValidation}
                      onChange={handleChange}  />
                  </div>
                  <div>{error?.civil_no && <p className="m-0" style={{ color: 'red' }}>{t(error?.civil_no)}</p>}</div>
</div>


  <div className="d-flex justify-content-center">
  <p className="m-0 my-2" style={{fontSize:"18px",fontWeight:"400",color:"#111111"}}>{t("AND")}</p>
  </div>


    <div className="border  p-3 mb-3 mt-2">                    
                     {/* quote id */}
                 <div className="input-group mb-2 mt-2 ">
                    <div className="input-group-prepend prepends">
                      <span className="input-group-text">{(lnstr === 'en') ? 'Quote ID' : 'معرف الاقتباس'}<span style={{color:'red', marginLeft: '5px'}}>*</span></span>
                    </div>
                    <input type="text" name="quote_id" ref={quoteRef} className="form-control "  value={formData?.quote_id} onBlur={handleValidation}
                      onChange={handleChange}  />
                  </div>
                  
                 {error?.quote_id && <p className="m-0" style={{ color: 'red' }}>{t(error?.quote_id)}</p>}
           
                
                     
     
            
  
          <>
            

         <div className="d-flex align-items-center my-3">
  <hr className="flex-grow-1" style={{borderTop: "1px solid #a7a7a7" }} />
  <p
    className="m-0 mx-2"
    style={{ fontSize: "18px", fontWeight: "400", color: "#111111" }}
  >
    {t("OR")}
  </p>
  <hr className="flex-grow-1 " style={{borderTop: "1px solid #a7a7a7" }}  />
</div>

  
              <div className="input-group mb-2 mt-2 ">
              
                    <div className="input-group-prepend prepends">
                      <span className="input-group-text">{(lnstr === 'en') ? 'Registration Mark' : 'علامة التسجيل'}<span style={{color:'red', marginLeft: '5px'}}>*</span></span>
                    </div>
             
          
                 <select ref={selectOpt1}  name="registration_mark" className="form-control" value={formData?.registration_mark} 
                //   onChange={handleChange}
                //   onBlur={handleValidation} 
                  >
        <option value={null}>--{t("Select")}--</option>
        {reg_mark.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
        </select>
       
              </div>
 {error?.registration_mark && <p style={{ color: 'red' }}>{t(error?.registration_mark)}</p>}
               
             
  
       <div className="input-group mb-2 mt-2 ">
                    <div className="input-group-prepend prepends">
                      <span className="input-group-text">{(lnstr === 'en') ? 'Registration Number' : 'رقم التسجيل'}<span style={{color:'red', marginLeft: '5px'}}>*</span></span>
                    </div>


                  <input
                    type='text'
                    ref={regNoRef}
                    className='form-control'
                    value={formData.registration_number}
                    name='registration_number'
                    onChange={handleChange}
                    onBlur={handleValidation}
                  />
                  </div>
                  {error?.registration_number && <p style={{ color: 'red' }}>{t(error?.registration_number)}</p>}
              </>
                
   </div>

 <div className="d-flex justify-content-end "> 
  <button className="btn-primary mt-3" 
  type="submit"
  onClick={(e)=>{handleSubmit(e)}}
  // style={{opacity :`${buttonClicked==="quote_id"||buttonClicked==="plate_no"?1:0.5}`}}
//   disabled
>
    {t("Renew My Policy")}
  </button>
  </div>

  
  

  
              
           
            
  
  
                    
                      </div>
  </div>
                      
                  </div>
  
                      </>
                


            </Col>

            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
    </>
        
      );
    
}


export default MotorRenewPolicy;